import React, { useContext, useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { AuthService } from "../../../services/auth-service";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import { PermissionService } from "../../../services/permission-service";
import AuthContext from "../../../context/auth-context";

export const Content = (props) => {
  const history = useHistory();

  const authCtx = useContext(AuthContext);

  const [submitloading, setSubmitLoading] = useState(true);

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      const adminToken = await AuthService.userLogin(
        values.email,
        values.password
      );

      const userInfo = await AuthService.userDetails(adminToken);
      // setAccessId(userInfo.role);
      const resultAccess = await PermissionService.accesslevelSearchDetails(
        userInfo.role
      );

      const result = await PermissionService.userpermissionDetails(
        resultAccess[0].id
      );

      localStorage.setItem("PermissionDetails", JSON.stringify(result));
console.log('userInfo', userInfo)
console.log('result', result)
      // authContext.dispatch({
      //   type: "INITIALISE",
      //   payload: {
      //     token: adminToken,
      //     user: userInfo,
      //     loggedIn: true,
      //   },
      // });

      setSubmitLoading(true);
      authCtx.onLoging();
      localStorage.setItem("Authtoken", adminToken);
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      notify('Loged Success!');
    
      // Check user access level and redirect accordingly
      const userAccessLevel = result[0]?.access_level?.access_level;
      if (userAccessLevel === "SALES_USER" || userAccessLevel === "STORE_USER") {
        history.replace("/orders");
      } else {
        history.replace("/dashboard-report");
      }
      
      
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else if (err.response.data.errors.Admin !== undefined) {
        notifyWarning(err.response.data.errors.Admin);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  // const userpermissionSearch = async () => {
  //   try {
  //     const result = await PermissionService.userpermissionDetails(accessId);

  //     localStorage.setItem("PermissionDetails", JSON.stringify(result));
  //   } catch (err) {
  //     //toast
  //   }
  // };

  useEffect(() => {
    // userpermissionSearch();
  }, []);

  return (
    <div className="ms-content-wrapper ms-auth">
      <div>
        <ToastContainer />
      </div>
      <div className="ms-auth-container">
        <div className="ms-auth-col">
          <div className="ms-auth-bg" />
        </div>
        <div className="ms-auth-col">
          <div className="ms-auth-form">
            <Formik
              initialValues={{
                email: "test13@gmail.com",
                password: "aaaaaa",
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string().email().required("Required"),
                password: Yup.string()
                  .required("Required")
                  .min(4, "password must have at least 5 characters")
                  .max(10, "password must have less than 10 characters"),
              })}
              onSubmit={onSubmitForm}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                touched,
                values,
                submitForm,
                isValid,
              }) => (
                <div>
                  <h3>Login to Account</h3>
                  <p>Please enter your email and password to continue</p>
                  <div className="mb-3">
                    <label htmlFor="validationCustom08">Email Address</label>
                    <div className="input-group">
                      <input
                        name="email"
                        type="email"
                        className="form-control"
                        id="ema"
                        placeholder="Email Address"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.email && errors.email}
                    </div>
                  </div>
                  <div className="mb-2">
                    <label htmlFor="validationCustom09">Password</label>
                    <div className="input-group">
                      <input
                        name="password"
                        type="password"
                        className="form-control"
                        id="pass"
                        placeholder="Password"
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {touched.password && errors.password}
                    </div>
                  </div>
                  {/* <div className="form-group">
                    <label className="ms-checkbox-wrap">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultValue
                      />{" "}
                      <i className="ms-checkbox-check" />
                    </label>{" "}
                    <span> Remember Password </span>
                    <label className="d-block mt-3">
                      <Link className="btn-link" to="/forgotpassword">
                        Forgot Password ?
                      </Link>
                    </label>
                  </div> */}
                  <div className="col-md-2" hidden={submitloading}>
                    <div className="spinner spinner-7">
                      <div className="bounce1" />
                      <div className="bounce2" />
                      <div className="bounce3" />
                    </div>
                  </div>
                  <button
                    className="btn btn-primary mt-4 d-block w-100"
                    type="button"
                    onClick={submitForm}
                  >
                    Sign In
                  </button>
                  {/* <p className="mb-0 mt-3 text-center">
                    Don't have an account?{" "}
                    <Link className="btn-link" to="/default-register">
                      Forgot Password
                    </Link>
                  </p> */}
                </div>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
